import * as types from './types';

export const accountingReportMutations = {
  [types.ReportData.SET.ALL](state, payload) {
    state.reportData = payload;
  } 
}